import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';

import { channelsListQuery } from '@/entities/channel';
import { IChannelsListResponseDto } from '@/shared/api/channels';

export function useChannelsList() {
  const { data, isPending, error } = useQuery<IChannelsListResponseDto>({
    ...channelsListQuery(),
  });

  return useMemo(() => {
    return {
      channels: data?.data?.length ? data.data : undefined,
      isPending,
      error,
    };
  }, [data?.data, isPending, error]);
}
